<style scoped>
.v-dialog__content {
  justify-content: left;
}
.border-error {
  border: 1px solid #ff5252 !important;
}
.content-box {
  height: 50px;
  border: 1px solid #cccc;
  cursor: pointer;
  overflow: auto;
  font-size: 12px;
  padding: 4px;
}
h5 {
  font-weight: 700;
  font-size: 12px;
  text-decoration: none;
}
.v-text-field input {
  font-size: 1.2em;
}
.airwaybill table {
  font-size: 12px;
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
}
/*** Table Styles **/

.table-fill {
  background: white;
  border-radius:3px;
  border-collapse: collapse;
  margin: auto;
  padding:2px;
  width: 100%;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  animation: float 5s infinite;
}
.v-input__slot {
  margin-bottom: 5px;
}
.v-text-field--box .v-label, .v-text-field--full-width .v-label, .v-text-field--outline .v-label {
  top: 5px;
}

th {
  color:#343a45;;
  background:#fff;
  border-bottom:4px solid #9ea7af;
  border-right: 1px solid #C1C3D1;
  font-weight: 700;
  padding:5px;
  text-align:left;
  vertical-align:middle;
}

tr.footer td {
  color:#343a45;;
  background:#fff;
  border-top:4px solid #9ea7af;
  border-right: 1px solid #C1C3D1;
  font-weight: 700;
  padding:5px;
  text-align:left;
  vertical-align:middle;
}

th:first-child {
  border-top-left-radius:3px;
}

th:last-child {
  border-top-right-radius:3px;
  border-right:none;
}

tr {
  border-top: 1px solid #C1C3D1;
  border-bottom-: 1px solid #C1C3D1;
  color:#666B85;
  font-weight:normal;
  text-shadow: 0 1px 1px rgba(256, 256, 256, 0.1);
}



tr:first-child {
  border-top:none;
}

tr:last-child {
  border-bottom:none;
}

tr:nth-child(odd) td {
  background:#EBEBEB;
}


tr:last-child td:first-child {
  border-bottom-left-radius:3px;
}

tr:last-child td:last-child {
  border-bottom-right-radius:3px;
}

td {
  background:#FFFFFF;
  padding:5px;
  text-align:left;
  vertical-align:middle;
  font-weight:300;
  text-shadow: -1px -1px 1px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #C1C3D1;
}

td:last-child {
  border-right: 0px;
}

th.text-left {
  text-align: left;
}

th.text-center {
  text-align: center;
}

th.text-right {
  text-align: right;
}

td.text-left {
  text-align: left;
}

td.text-center {
  text-align: center;
}

td.text-right {
  text-align: right;
}

.v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
  padding: 0 5px;
}

table input {
  width: 100%;
}
.v-input {
  font-size: 12px !important;
}
.v-card__title {
  padding: 8px 16px !important;
}
.v-card__text {
  padding: 16px !important;
  width: 100%;
}
.v-card__text .container {
  padding: 0  !important;
  width: 100%;
}
</style>
<style>
.v-messages {
  min-height: 0px !important;
}
.v-text-field__details {
  margin-bottom: 0px !important;
}

.airwaybill .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px;
}
.airwaybill .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.airwaybill .v-input--selection-controls__input {
  height: 12px;
}
.airwaybill .v-label {
  font-size: 12px;
}
.airwaybill .v-text-field.v-text-field--solo .v-input__control {
  min-height: 10px;
  padding: 0;
}
.airwaybill .v-input__controls {
  max-height: 55px !important;
}
.airwaybill .v-select {
  max-height: 55px !important;
}
</style>
<style>
.airwaybill {
  .v-text-field--box .v-label, .v-text-field--full-width .v-label, .v-text-field--outline .v-label {
    top: 5px;
  }
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
.viewer-wrapper {
  position: fixed;
  background: #333;
  height: auto;
}
.methods {
  margin-bottom: 1em;
  flex-wrap: wrap;
  & > * {
    margin-right: 0.75rem;
  }
}
.options-panel {
  .panel-block {
    padding: 0;
    .checkbox {
      display: block;
      width: 100%;
      margin: 0;
      padding: 0.5em 0.75em;
    }
  }
}
.viewer {
  height: 100%;
  .images {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px;
    .image-wrapper {
      display: inline-block;
      width: calc(33% - 20px);
      margin: 5px 5px 0 5px;
      .image {
        width: 100%;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
}
</style>
<template>
  <scrollbar class="scroll-area" :settings="settings">

    <v-container fluid grid-list-md class="airwaybill"  v-if="showForm">
      <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      top="top"
      vertical="vertical"
      >
      {{ snackbarText }}
      <v-btn
      color="pink"
      flat
      @click="snackbar = false"
      >
      Close
    </v-btn>
  </v-snackbar>

  <template>

    <v-layout row wrap v-if="form && form.numberDetail && form.numberDetail.serialNumber">
      <v-flex xs7>

        <v-layout row wrap>
          <v-flex xs12>
            <table class="form-table">
              <thead>
                <tr>
                  <th class="column text-xs-left"></th>
                  <th class="column text-xs-left">Number</th>
                  <th class="column text-xs-left">Origin</th>
                  <th class="column text-xs-left">Dest</th>
                  <th class="column text-xs-left">Description</th>
                  <th class="column text-xs-right">Pcs</th>
                  <th class="column text-xs-right">Wgt (kgs)</th>
                  <th class="column text-xs-left">Consignor</th>
                  <th class="column text-xs-left">Consignee</th>
                  <th class="column text-xs-left">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in documents" v-on:click="setItem(item)">
                  <td>{{ i+1}}</td>
                  <td class="column text-xs-left" v-if="item == form" style="border-left: 3px solid green">{{ item.numberDetail.houseSerialNumber }}</td>
                  <td class="column text-xs-left" v-else>{{ item.numberDetail.houseSerialNumber }}</td>
                  <td class="column text-xs-left">{{ item.routingDestinationAndChargesDetail.airportOfDeparture }}</td>
                  <td class="column text-xs-left">{{ item.routingDestinationAndChargesDetail.airportOfDestination }}</td>
                  <td class="column text-xs-left">
                    <span v-if="item.airWaybillTable.airWaybillItems[0].goodsDescription  && item.airWaybillTable.airWaybillItems[0].goodsDescription.length > 20">{{ item.airWaybillTable.airWaybillItems[0].goodsDescription.substring(0, 40) }} ...</span>
                    <span v-else>{{ item.airWaybillTable.airWaybillItems[0].goodsDescription }}</span>
                  </td>
                  <td class="column text-xs-right">{{ item.airWaybillTable.airWaybillItems[0].numberOfPieces }}</td>
                  <td class="column text-xs-right">{{ item.airWaybillTable.airWaybillItems[0].grossWeight }}</td>
                  <td class="column text-xs-left">{{ item.shippingDetail.name }}</td>
                  <td class="column text-xs-left">{{ item.consigneeDetail.name }}</td>
                  <td class="column text-xs-left">{{ item.status }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="footer">
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-right">{{ getTotalNumberOfPieces() }}</td>
                  <td class="column text-xs-right">{{ getTotalGrossWeight() }}</td>
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-left"></td>
                  <td class="column text-xs-left"></td>
                </tr>
              </tfoot>
            </table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs3>
            <v-text-field style="height: 50px;" v-validate="'required'" name="form.numberDetail.serialNumber" :hide-details="true" :error-messages="errors.collect('form.numberDetail.serialNumber')" label="Master AWB Number" v-on:click="pasteSelect(form.numberDetail, 'serialNumber')"  v-model="form.numberDetail.serialNumber" placeholder=" " outline></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field style="height: 50px;" v-validate="'required'" name="form.numberDetail.houseSerialNumber" :hide-details="true" :error-messages="errors.collect('form.numberDetail.houseSerialNumber')" label="House AWB Number" v-on:click="pasteSelect(form.numberDetail, 'houseSerialNumber')" v-model="form.numberDetail.houseSerialNumber" placeholder=" " outline></v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-validate="'required'" name="form.routingDestinationAndChargesDetail.airportOfDeparture" @click="pasteSelect(form.routingDestinationAndChargesDetail, 'airportOfDeparture')" :hide-details="true" :error-messages="errors.collect('form.routingDestinationAndChargesDetail.airportOfDeparture')" v-model="form.routingDestinationAndChargesDetail.airportOfDeparture"  label="Airport Of Departure" placeholder=" " outline></v-text-field>

                <!-- <v-autocomplete v-validate="'required'" name="form.routingDestinationAndChargesDetail.airportOfDeparture" :hide-details="true" :error-messages="errors.collect('form.routingDestinationAndChargesDetail.airportOfDeparture')" :search-input.sync="searchDeparture" v-model="form.routingDestinationAndChargesDetail.airportOfDeparture" :items="searchDepartureList" item-value="iata" item-text="item_text" label="Airport Of Departure" placeholder=" " outline></v-autocomplete> -->

              </v-flex>
              <v-flex xs6>
                <v-text-field v-validate="'required'" name="form.routingDestinationAndChargesDetail.airportOfDestination" @click.native="pasteSelect(form.routingDestinationAndChargesDetail, 'airportOfDestination')" :hide-details="true" :error-messages="errors.collect('form.routingDestinationAndChargesDetail.airportOfDestination')"  v-model="form.routingDestinationAndChargesDetail.airportOfDestination" label="Airport Of Destination" placeholder=" " outline></v-text-field>

                <!-- <v-autocomplete v-validate="'required'" name="form.routingDestinationAndChargesDetail.airportOfDestination" :hide-details="true" :error-messages="errors.collect('form.routingDestinationAndChargesDetail.airportOfDestination')" :search-input.sync="searchArrival" v-model="form.routingDestinationAndChargesDetail.airportOfDestination" :items="searchArrivalList" item-value="iata" item-text="item_text" label="Airport Of Destination" placeholder=" " outline></v-autocomplete> -->

              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="form && form.numberDetail && form.numberDetail.serialNumber">
          <v-flex xs6>
            <v-flex xs12>
              <!--<h5><v-icon color="green darken-2">edit</v-icon> Shipper's Name And Address</h5>-->
              <h5>Shipper's Name And Address</h5>
              <div :class="'content-box ' + customErrors.classes.shippingDetail" v-on:click="shippingDetailsDialog = true; addressKey = 'shippingDetail'; addressTitle = 'Shipper\'s Details'; addressDetails = form.shippingDetail;selectAddress(form.shippingDetail);" >
                <span v-if="form.shippingDetail.address.name">{{ form.shippingDetail.address.name }} </br></span>
                <span v-html="niceString(form.shippingDetail.address.address)"></span>
              </div>
            </v-flex>
            <v-flex xs12>
              <!--<h5><v-icon color="green darken-2">edit</v-icon> Shipper's Name And Address</h5>-->
              <h5>Consignee's Name And Address</h5>
              <div :class="'content-box ' + customErrors.classes.consigneeDetail" v-on:click="shippingDetailsDialog = true; addressKey = 'consigneeDetail'; addressTitle = 'Consignee\'s Details'; selectAddress(form.consigneeDetail);">
                <span v-if="form.consigneeDetail.address.name">{{ form.consigneeDetail.address.name }} </br></span>
                <span v-html="niceString(form.consigneeDetail.address.address)"></span>
              </div>
            </v-flex>

            <v-flex xs12>
              <v-flex xs12>
                <table class="">
                  <thead>
                    <tr>
                      <th class="column text-xs-right">No. Of Pieces</th>
                      <th class="column text-xs-right">Gross Weight (KG)</th>
                      <th class="column text-xs-left">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="i == 0" v-for="(item, i) in form.airWaybillTable.airWaybillItems">
                      <td class="column text-xs-right"><input class="text-xs-right" type="text" v-model="item.numberOfPieces" v-on:click="pasteSelect(item, 'numberOfPieces')" /></td>
                      <td class="column text-xs-right"><input class="text-xs-right" type="text" v-model="item.grossWeight" v-on:click="pasteSelect(item, 'grossWeight')" /></td>
                      <td class="column text-xs-left">
                        <input type="text" v-model="item.goodsDescription" v-on:click="pasteSelect(item, 'goodsDescription')" />
                      </td>
                    </tr>
                  </tbody>

                </table>
              </v-flex>
            </v-flex>

          </v-flex>

          <v-flex xs6>
            <v-layout row wrap v-show="showRequestedRouting">
              <v-flex xs6>
                <v-autocomplete v-validate="'required'" name="form.routingDestinationAndChargesDetail.currency" :hide-details="true" :error-messages="errors.collect('form.routingDestinationAndChargesDetail.currency')" :items="currencies" v-model="form.routingDestinationAndChargesDetail.currency" item-value="code" item-text="description" label="Currency" placeholder=" " outline></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Amount Of insurance *" v-model="form.routingDestinationAndChargesDetail.amountOfInsurance" placeholder="Enter Amount Or XXX" outline></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-show="showRequestedRouting">
              <v-flex xs6>
                <v-flex xs12 pa-0><h5>Weight & Valuation Charge</h5></v-flex>
                <v-radio-group row v-model="form.routingDestinationAndChargesDetail.weightAndValuationCharge">
                  <v-radio value="PP" label="Prepaid"></v-radio>
                  <v-radio value="COL" label="Collect"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs6>
                <v-flex xs12 pa-0><h5>Other Charges</h5></v-flex>
                <v-radio-group row v-model="form.routingDestinationAndChargesDetail.otherCharges">
                  <v-radio value="PP" label="Prepaid"></v-radio>
                  <v-radio value="COL" label="Collect"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-show="showRequestedRouting">
              <v-flex xs6>
                <v-text-field label="Declared Value For Carriage *" v-model="form.routingDestinationAndChargesDetail.declaredValueForCarriage" placeholder="Enter Amount Or NVD" outline></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Declared Value For Customs *" v-model="form.routingDestinationAndChargesDetail.declaredValueForCustoms" placeholder="Enter Amount Or NCV" outline></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- handling details row -->
          <v-flex xs8>
            <v-flex xs12 @click="showHandlingDetails = !showHandlingDetails"><h5>Handling Details</h5></v-flex>
            <v-autocomplete v-show="showHandlingDetails" :multiple="true" v-model="form.handlingInformationDetail.codes" :chips="true" :clearable="true" :items="handlingCodes" item-value="code" item-text="description" label="Handling Codes" placeholder=" " outline></v-autocomplete>
          </v-flex>
          <v-flex xs4  v-show="showHandlingDetails">
            <v-flex xs12><h5>&nbsp;</h5></v-flex>
            <v-text-field label="SCI" v-model="form.handlingInformationDetail.sci" placeholder=" " outline></v-text-field>
          </v-flex>
          <v-flex xs6  v-show="showHandlingDetails">
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea label="SSR : Special Service Request" v-model="form.handlingInformationDetail.specialServiceRequest" placeholder=" " outline></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6  v-show="showHandlingDetails">
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea label="OSI : Other Service Information" v-model="form.handlingInformation.osi" placeholder=" " outline></v-textarea>
              </v-flex>
            </v-layout>
          </v-flex>


        </v-layout>
      </v-flex>
      <v-flex xs5 text-center>
        <!--
        <v-btn color="success darken-3" v-on:click="save('save')">Save AWB</v-btn>
        <v-btn color="success" v-on:click="save('preview')">Save And Send AWB</v-btn>
        -->
        <v-btn color="success darken-3" v-on:click="save('save', false)">Save</v-btn>
        <v-btn color="success" v-on:click="save('preview')">Send</v-btn>
        <v-btn color="success" v-if="!saveAndSendingAll" v-on:click="save('saveAndSendAll', false, false)">Send All</v-btn>
        <v-btn color="blue darken-1" flat v-if="saveAndSendingAll"><v-progress-circular indeterminate color="green" :size="14" :width="2"></v-progress-circular>&nbsp; &nbsp; ...&nbsp;</v-btn>
        <v-btn color="blue darken-3" v-on:click="convertHAWBToMAWBDialog = true;">Convert To Master</v-btn>
        <copiable-image :documentImage="hawbDocumentImage" :angle="form.angle" :onSelect="onSelect" v-if="hawbDocumentImage" :key="hawbDocumentImage" />
        <!-- <div class="viewer-wrapper">
          <div :options="options" class="viewer" ref="viewer">
            <img :src="documentImage" width="100%" @load="startViewer()" />
          </div>
        </div> -->

      </v-flex>
    </v-layout>
  </template>
  <!-- consignment rating details dialog -->
  <v-dialog class="airwaybill" v-model="consignmentRatingDetailsDialog" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Consignment Rating Item</span>
      </v-card-title>
      <v-card-text v-if="activeRatingLine">
        <v-container grid-list-md p-0  class="airwaybill">
          <v-layout row wrap>
            <v-flex xs12><h5>&nbsp;</h5></v-flex>
            <v-flex xs2>
              <v-text-field label="No. Of Pieces *" v-model="activeRatingLine.numberOfPieces" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field label="Gross Weight" v-model="activeRatingLine.grossWeight" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-autocomplete :items="metrics" item-value="code" item-text="description" label="KG/LB"  v-model="activeRatingLine.chargeableWeightKgLb" outline></v-autocomplete>
            </v-flex>
            <v-flex xs1>
              <v-autocomplete :items="rateClasses" item-value="code" item-text="description" label="Rate Class"  v-model="activeRatingLine.rateClassCode" outline></v-autocomplete>
            </v-flex>
            <v-flex xs2>
              <v-text-field label="Chargeable Weight" v-on:keyup="updateTotal(activeRatingLine)" v-model="activeRatingLine.chargeableWeight" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field label="Rate Charge" v-on:keyup="updateTotal(activeRatingLine)" v-model="activeRatingLine.rateCharge" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field label="Total" v-model="activeRatingLine.totalAmount" required outline placeholder=" "></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-layout wrap>

                <v-flex xs4>
                  <v-text-field label="SLAC" v-model="activeRatingLine.slac" required outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="RCP" v-model="activeRatingLine.rcp" required outline placeholder=" "></v-text-field>
                </v-flex>


                <v-flex xs6>
                  <v-text-field label="Commodity Item Number" v-model="activeRatingLine.commodityItemNumber" outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Volume" v-model="activeRatingLine.volume" outline placeholder=" "></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="ULD Type" v-model="activeRatingLine.uldType" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="ULD Serial Number" v-model="activeRatingLine.uldSerialNumber" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field label="ULD Owner Code" v-model="activeRatingLine.uldOwnerCode" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="ULD Rate Class Type" v-model="activeRatingLine.uldRateClassType" placeholder=" " outline></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field label="Harmonised Commodity Code" v-model="activeRatingLine.harmonisedComodityCode" placeholder=" " outline></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>

              <v-flex xs12><h5>Nature And Quantity Of Goods</h5></v-flex>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea label="Description" placeholder=" " v-model="activeRatingLine.goodsDescription" outline></v-textarea>
                </v-flex>
                <v-flex xs12><h5>Dimensions</h5></v-flex>
                <v-flex xs12>
                  <table class="form-table">
                    <thead>
                      <tr>
                        <th class="column text-xs-left">Length</th>
                        <th class="column text-xs-center">Width</th>
                        <th class="column text-xs-left">Height</th>
                        <th class="column text-xs-left">CM/IN</th>
                        <th class="column text-xs-left">No. Of Units</th>
                      </tr>

                    </thead>
                    <tbody>
                      <tr v-for="item in form.airWaybillTable.dimensions">
                        <td class="column text-xs-center"><input type="text" v-model="item.length" /></td>
                        <td class="column text-xs-center"><input type="text" v-model="item.width" /></td>
                        <td class="column text-xs-center"><input type="text" v-model="item.height" /></td>
                        <td class="column text-xs-center"><input type="text" v-model="item.measurement" /></td>
                        <td class="column text-xs-center"><input type="text" v-model="item.numberOfPieces" /></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>


              </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="consignmentRatingDetailsDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="consignmentRatingDetailsDialog = false; saveRatingLine(activeRatingLine);">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- convertHAWBToMAWBDialog -->
  <v-dialog v-model="convertHAWBToMAWBDialog" persistent max-width="600px" :hide-overlay="true">
    <v-card>
      <v-card-title>
        <span class="headline">Convert House AWB To Master AWB</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
               <v-text-field label="Master AWB No. *" v-model="form.numberDetail.serialNumber" required outline placeholder=" " v-on:click="pasteSelect(form.numberDetail, 'serialNumber')"></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="convertHAWBToMAWBDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="convertHAWBToMAWB()">Save</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- convertHAWBToMAWBDialog -->

  <!-- shipping details dialog -->
  <v-dialog v-model="messageDialog" persistent max-width="900px" :hide-overlay="true">
    <v-card>
      <v-card-title>
        <span class="headline">Message</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm12 md12>
              <v-text-field label="Email Address *" v-model="messageEmail" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs8 style="font-size: 10px">
              <pre style="overflow: scroll">{{ message }}</pre>
            </v-flex>
            <v-flex xs4 style="font-size: 12px; color: #fff">
              <div class="error" style="padding: 10px" v-if="customErrors.errors.length || errors.all().length">
                <div><i aria-hidden="true" class="v-icon material-icons theme--light v-alert__icon">warning</i> Errors and warnings</div>
                <ul>
                  <li v-for="error in errors.all()">{{ error }}</li>
                  <li v-for="error2 in customErrors.errors">{{ error2.message }}</li>
                </ul>
              </div>

            </v-flex>


          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="messageDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat v-if="!sending" @click="save('saveAndSend')">Send</v-btn>
        <v-btn color="blue darken-1" flat v-if="sending"><v-progress-circular indeterminate color="green" :size="14" :width="2"></v-progress-circular>&nbsp; &nbsp;Sending...&nbsp;</v-btn>



      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- shipping details dialog -->
  <v-dialog v-model="shippingDetailsDialog" persistent max-width="600px" :hide-overlay="true">
    <v-card>
      <v-card-title>
        <span class="headline">{{ addressTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          
          <v-layout wrap>
            <v-flex xs12>
          <v-text-field
            :append-icon="'search'"
            outline
            clear-icon="close"
            clearable
            label="Search address"
            type="text"
             v-model="addressQuery"  
             v-on:keyup="searchAddress(addressKey)"
             @click:clear="clearAdressList()"
            autocomplete="off"
          ></v-text-field>
        </v-flex>
      <v-flex xs12>
        <table class="v-datatable v-table theme--light">
        <tbody>
                      <tr v-for="item in addressList" v-on:click="replaceAddress(item, addressKey)" style="cursor: pointer">
                        <td>{{ item[0] }}</td>
                        <td>{{ item[1] }}</td>
                        <td>{{ item[2] }}</td>
                      </tr>
                      </tbody>
                      </table>
      </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Name *" v-model="form[addressKey].address.name" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Account Number" v-model="form[addressKey].accountNumber" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea label="Address" v-model="form[addressKey].address.address" outline placeholder=" ">

              </v-textarea>
            </v-flex>
            <v-flex xs12 sm2 md2>
              <v-text-field label="City Code" v-model="form[addressKey].address.cityCode"  outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-text-field label="Location" v-model="form[addressKey].address.city"  outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-text-field label="Zip/Post Code" v-model="form[addressKey].address.zipOrPostalCode"  outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-autocomplete label="Country" v-model="form[addressKey].address.countryCode" :items="countries" item-value="code" item-text="name" outline placeholder=" "></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Telephone" v-model="form[addressKey].telephone" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Fax" v-model="form[addressKey].fax"  outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="typeof form[addressKey].agentIATACode != 'undefined'">
              <v-text-field label="Agent's IATA Code" v-model="form[addressKey].agentIATACode" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6 v-if="typeof form[addressKey].cassAddress != 'undefined'">
              <v-text-field label="CASS Address" v-model="form[addressKey].cassAddress"  outline placeholder=" "></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="shippingDetailsDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="shippingDetailsDialog = false; saveAddress(addressKey, form[addressKey])">Save</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- end shipping details dialog -->
  <!-- issuing carrier details -->
  <v-dialog v-model="issuingCarrierDetailsDialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Issuing Carrier Details</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Name *" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea label="Address" outline placeholder=" "></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Telephone" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Fax" outline placeholder=" "></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="issuingCarrierDetailsDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="issuingCarrierDetailsDialog = false">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- end issuing carrier details -->
  <!-- issuing carrier agent details -->
  <v-dialog v-model="issuingCarrierAgentDetailsDialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Issuing Carrier's Agent Details</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Name *" required outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea label="Address" v-model="addressDetails" outline placeholder=" "></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Agents IATA Code" v-model="form.agentsIATACode" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="Account Number" v-model="form.accountNo" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field label="CASS Address" v-model="form.cassAddress" outline placeholder=" "></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-checkbox label="Commissionable" type="checkbox"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="issuingCarrierAgentDetailsDialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="issuingCarrierAgentDetailsDialog = false">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- end issuing carrier agent details -->
</v-container>
</scrollbar>
</template>
<script>

import ApiService from '@/services/api.service';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {getFromStorage, saveInStorage, removeFromStorage, clearStorage} from '@/services/localstorage.service';
import {createNamespacedHelpers} from 'vuex';
import JwtService from "@/services/jwt.service";
import CopiableImage from '@/components/charts/image/copiable/chart.vue';
import {selectWord, selectParagraph, selectAddress, saveAddress, searchAddress} from '@/models/awb';

let user = JwtService.getUser();

const {mapState, mapActions, mapGetters, mapMutations} = createNamespacedHelpers('charts');
import awb from '@/store/modules/awb';
const awbNamespace = createNamespacedHelpers('awb');

// import 'viewerjs/dist/viewer.css';
// import Viewer from 'viewerjs';
// import { Validator } from 'vee-validate';
//import Viewer from 'v-viewer';
//import Vue from 'vue';
//Vue.use(Viewer);

const dict = {
  custom: {
    'form.numberDetail.airlineCode': {
      required: 'Airline code is required'
    },
    'form.numberDetail.serialNumber': {
      required: 'Serial number is required'
    },
    'form.routingDestinationAndChargesDetail.airportOfDeparture': {
      required: 'Airport of departure is required'
    },
    'form.routingDestinationAndChargesDetail.airportOfDestination': {
      required: 'Airport of destination is required'
    },
    'form.routingDestinationAndChargesDetail.currency': {
      required: 'Curreny is required'
    }

  }
};
//
let ratingLineDimensionTemplate = {length: null, width: null, height: null, metric: null, numberOfUnits: null};
export default {
  props: ['email'],
  name: 'hawb-form',
  data: function() {
    return {
      addressQuery: null,
      addressList: [],
      selection: null,
      saveAndSendingAll: false,
      interval: null,
      _documents: [],
      sending: false,
      messageDialog: false,
      convertHAWBToMAWBDialog: false,
      messageEmail: null,
      customErrors: {
        errors: [],
        messages: [],
        classes: {
          shippingDetail: '',
          consigneeDetail: '',
          issuingCarriersAgentDetail: '',
          routingDestinationAndChargesDetail: '',
          airWaybillTableOtherCharges: '',
          airWaybillTableItems: '',
          airWaybillTableSummary: ''
        }
      },
      message: "",
      //searchAirport: null,
      searchDeparture: null,
      showRequestedRouting: true,
      showChargesDetails: true,
      showHandlingDetails: false,
      searchDepartureList: [],
      searchArrival: null,
      searchArrivalList: [],
      searchAirline: null,
      countries: [],
      addressKey: 'shippingDetail',
      addressTitle: "Shipper's Details",
      documentId: null,
      snackbar: false,
      snackbarText: "",
      startTime: null,
      originalForm: null,
      settings: {
        maxScrollbarLength: 60
      },
      //showForm: false,
      documentData: {},
      viewer: null,
      documentImage: null,
      options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": false, "keyboard": false },
      menu: false,
      currentDocument: null,
      currentFile: null,
      imageUrl: "https://taybull.s3.eu-west-2.amazonaws.com/textract/project_id_1/",
      accountingInformationCodes: [
        {code: "GBL", description: "GBL - Government Bill Of Lading"},
        {code: "GEN", description: "GEN - General Information"},
        {code: "MCO", description: "MCO - Misc Charge Of Order"},
        {code: "RET", description: "RET - Return To Origin"},
        {code: "SRN", description: "SRN - Shipper Reference Number"},
        {code: "STL", description: "STL - Mode Of Settlement"}
      ],
      consignmentRatingDetailsDialog: false,
      shippingDetailsDialog: false,
      addressDetails: "",
      issuingCarrierDetailsDialog: false,
      issuingCarrierAgentDetailsDialog: false,
      airlines: [],
      handlingCodes: [],
      currencies: [],
      rateClasses: [],
      metrics: [
        {code: "KG", description: "KG"},
        {code: "LB", description: "LB"}
      ],
      otherCharges: [],
      ratingLineDimensionTemplate: ratingLineDimensionTemplate,
      activeRatingLine: null,
      selectedRatingLine: null,
      ratingLineTemplate: {
        added: false,
        numberOfPieces: 0,
        slac: null,
        rcp: null,
        grossWeight: null,
        grossWeightKgLb: null,
        rateClassCode: null,
        commodityItemNumber: null,
        rateClassPercentage: null,
        volume: null,
        mc: null,
        volumetricWeight: null,
        volumetricWeightKgLb: null,
        chargeableWeight: 0.00,
        chargeableWeightKgLb: null,
        rateCharge: 0.00,
        totalAmount: null,
        rateAsAgreed:null,
        goodsDescription: null,
        dimensions: [],
        uldType: null,
        uldSerialNumber: null,
        uldOwnerCode: null,
        uldRateClassType: null,
        harmonisedComodityCode: null
      },
      _form: null,
      form2: null,
      form1: {
        airlineCode: "",
        airportCode: "",
        serialNumber: "",
        shippersNameAndAddress: "",
        consigneesNameAndAddress: "",
        issuingCarriersNameAndCity: "",
        shippersDetails: {
          name: "",
          accountNumber: "",
          addressLines: "",
          postCode: "",
          telephoneNumber: "",
          faxNumber: ""
        },
        issuingCarrierDetails: {
          name: "",
          accountNumber: "",
          addressLines: "",
          postCode: "",
          telephoneNumber: "",
          faxNumber: ""
        },
        consigneeDetails: {
          name: "",
          accountNumber: "",
          addressLines: "",
          postCode: "",
          telephoneNumber: "",
          faxNumber: ""
        },
        issuingCarrierAgentDetails: {
          name: "",
          accountNumber: "",
          iataCode: "",
          cassAddress: "",
          commissionable: false,
          addressLines: "",
          postCode: "",
          telephoneNumber: "",
          faxNumber: ""
        },
        accountingInformation: "",
        airportOfDepartureAndRequestedRouting: {
          airportOfDeparture: "",
          airportOfDestination: "",
          details: [
            {
              carrierCode: "",
              flightNumber: "",
              departureAirportOrCity: "",
              departureDate: "",
              arrivalAirportOrCity: "",
              arrivalDate: ""
            },
            {
              carrierCode: "",
              flightNumber: "",
              departureAirportOrCity: "",
              departureDate: "",
              arrivalAirportOrCity: "",
              arrivalDate: ""
            },
            {
              carrierCode: "",
              flightNumber: "",
              departureAirportOrCity: "",
              departureDate: "",
              arrivalAirportOrCity: "",
              arrivalDate: ""
            },
            {
              carrierCode: "",
              flightNumber: "",
              departureAirportOrCity: "",
              departureDate: "",
              arrivalAirportOrCity: "",
              arrivalDate: ""
            },
            {
              carrierCode: "",
              flightNumber: "",
              departureAirportOrCity: "",
              departureDate: "",
              arrivalAirportOrCity: "",
              arrivalDate: ""
            },
            {
              carrierCode: "",
              flightNumber: "",
              departureAirportOrCity: "",
              departureDate: "",
              arrivalAirportOrCity: "",
              arrivalDate: ""
            }
          ]
        },
        shippingInformation: {
          referenceNumber: "",
          optionalShippingInformation: ""
        },
        chargesInformation: {
          currency: "",
          chargesCode: "",
          weightAndValuationChargePPCol: "", // Prepaid (PPD) or Collect COLL
          otherChargePPCol: "", // Prepaid (PPD) or Collect COLL
          declaredValueForCarriage: "", // placeholder Enter amount or NVD
          declaredValueForCustoms: "",
          amountOfInsurance: "" // Enter amount or XXX
        },
        handlingInformation: {
          description: "",
          specialHandlingCodes: [],
          sci: "",
          alsoNotify: "",
          ssr: "",
          osi: ""
        },
        consignmentRatingDetails: {

          items: []
        },
        otherCharges: {
          details: [
            {
              code: "",
              due: "",
              amount: 0.00
            }
          ]
        }

      },
      airports: []
    }
  },
  components: {
    'scrollbar': VuePerfectScrollbar,
    'copiable-image': CopiableImage
  },
  computed: {
    ...awbNamespace.mapState({
      form: state => state.hawb,
      hawb: state => state.hawb,
      showForm: state => state.showForm,
      documents: state => state.hawbs,
      hawbDocumentImage: state => state.hawbDocumentImage
    }),
    ...mapState(['parameterisedFilterObject']),

  },
  watch: {
    searchArrival(val) {
      // console.log("searchArrival", val);
      let values = [val];
      if(typeof this.form.routingDestinationAndChargesDetail.airportOfDestination != "undefined") {
        values.push(this.form.routingDestinationAndChargesDetail.airportOfDestination);
      }
      this.loadAirports("searchArrivalList", this.searchArrivalList, values);
    },
    searchDeparture(val) {
      let values = [val];
      if(typeof this.form.routingDestinationAndChargesDetail.airportOfDeparture != "undefined") {
        values.push(this.form.routingDestinationAndChargesDetail.airportOfDeparture);
      }
      this.loadAirports("searchDepartureList", this.searchDepartureList, values);
    }
  },
  methods: {
    ...awbNamespace.mapMutations(['mInit', 'mSetHAWB', 'mSetTab', 'mEnableHAWBLoad']),
    ...awbNamespace.mapActions(['aInit', 'loadMAWB', 'loadHAWBs', 'aLoadBySerialNumber']),
    async convertHAWBToMAWB() {
      this.convertHAWBToMAWBDialog = false;
      this.form.documentType = "MAWB";
      await this.save('save');
      this.mSetTab('master-awb'); 
      this.mEnableHAWBLoad();
      this.aLoadBySerialNumber(this.form.numberDetail.serialNumber);

    },
    clearAdressList() {
      console.log("clearAdressList");
      this.addressList = [];
    },
    replaceAddress(address, key) {
      console.log("address[4]", address[4]);
      console.log("key", key);

      this.form[key] = JSON.parse(address[4]);
      this.clearAdressList();
      this.addressQuery = null;
    },
    async searchAddress(type) {
      if(!this.addressQuery) {
        this.addressList = [];
      }
      if(this.addressQuery && this.addressQuery.length > 1) {
        const addressList = await searchAddress(type, this.addressQuery);
        if(Array.isArray(addressList) && addressList.length > 0) {
          this.addressList = addressList;
        }
      }
    },
    async saveAddress(type, address) {
      await saveAddress(type, address);
    },
    onSelect: async function(selection) {
      this.selection = selection;
    },
    pasteSelect: async function(obj, key, thisKey) {
      if(this.selection) {
        let data;
        if(this.selection.w > 0) {
          data = await selectParagraph(this.documentId, this.selection);
        } else {
          data = await selectWord(this.documentId, this.selection);
        }

        if(data) {

          if(typeof thisKey != "undefined") {
            this[thisKey] = data;
            console.log("first", data);
          }
            obj[key] = data;
            console.log("third", data);



        }
        this.selection = null;
      }
    },
    selectAddress: async function(node) {
      if(this.selection) {
        let data = await selectAddress(this.documentId, this.selection);
        node = Object.assign(node, data);
        this.selection = null;
      }
    },
    updateTotal: function(activeRatingLine) {
      // console.log("updateTotal", activeRatingLine);
      activeRatingLine.totalAmount = Number.parseFloat(Number.parseFloat(activeRatingLine.chargeableWeight)*Number.parseFloat(activeRatingLine.rateCharge)).toFixed(2);
      // this.activeRatingLine.totalAmount = activeRatingLine.totalAmount;
    },
    searchAirport(val) {
      // console.log(val);
      this.loadAirports();
    },
    loadAirports(key, list, values) {

      let q = null;
      let cache = {};
      for(let i = 0; i < values.length; i++) {

        try {
          let v = values[i].trim().toLowerCase();
          console.log("letvalue", v);
          if(v) {
            v = v.replace(/[^a-z0-9\s]/gi, "").replace(/\s\s+/g, ' ').replace(/ /g, ' & ');
            if(!q) {
              q = "(" + v + ")";
            } else {
              q = q + " | (" + v + ")";
            }
          }
        } catch(err) {
          console.log("err", err);
        }
      }

      if(q) {
        let airportSQL = "SELECT concat_ws(' - ', iata, name) as item_text, iata FROM airport_airlines_airports_979 WHERE document_tokens @@ to_tsquery('simple', '" + q + "') ORDER BY iata ASC LIMIT 100";
        console.log("airportSQL ", airportSQL);
        this.load(key, airportSQL, list, false);

      }
      //  let val1 = this.form.routingDestinationAndChargesDetail.airportOfDeparture;
      //  let val2 = this.form.routingDestinationAndChargesDetail.airportOfDestination;
      //let airlineSQL = "SELECT concat_ws(' - ', iata_code_mawb, iata_code, iata_airlines) as item_text, * FROM airport_airlines_airlines_979 WHERE concat_ws(' ', iata_code_mawb, iata_code, iata_airlines) LIKE %" + val + "% ORDER BY iata_code_mawb ASC";


    },
    financial: function(x) {
      return Number.parseFloat(x).toFixed(2);
    },
    validate: function() {
      let form = this.form;
      this.$validator.validateAll().then(function(response) {
        if(response === true) {
          // signIn(payload);
        }
      }).catch(function(e) {

      });

      this.customErrors.classes.shippingDetail = '';
      this.customErrors.classes.consigneeDetail = '';
      this.customErrors.classes.issuingCarriersAgentDetail = '';
      this.customErrors.classes.routingDestinationAndChargesDetail = '';
      this.customErrors.classes.airWaybillTableOtherCharges = '';
      this.customErrors.classes.airWaybillTableItems = '';
      this.customErrors.classes.airWaybillTableSummary = '';

      try {
        this.customErrors.errors = [];
        if(!form.shippingDetail.address.countryCode || !form.shippingDetail.address.city) {

          this.customErrors.errors.push({message: "Shipper country/location required", key: "form.shippingDetail"});
          this.customErrors.classes.shippingDetail = "border-error";
          //console.log("this.customErrors", this.customErrors);
        }

        if(!form.consigneeDetail.address.countryCode || !form.consigneeDetail.address.city) {

          this.customErrors.errors.push({message: "Consignee country/location required", key: "form.shippingDetail"});
          this.customErrors.classes.consigneeDetail = "border-error";
          //console.log("this.customErrors", this.customErrors);
        }

        if((!form.consigneeDetail.telephone && form.consigneeDetail.address.countryCode == "CN")) {
          this.customErrors.errors.push({message: "Consignee telephone required for China", key: "form.consigneeDetail"});
          this.customErrors.classes.consigneeDetail = "border-error";
        }

        if(!form.issuingCarriersAgentDetail.agentIATACode) {

          this.customErrors.errors.push({message: "Agent's IATA code required", key: "form.issuingCarriersAgentDetail"});
          this.customErrors.classes.issuingCarriersAgentDetail = "border-error";
          //console.log("this.customErrors", this.customErrors);
        }

      } catch(err) {

      }
      // Check country codes
    },
    getTotalNumberOfPieces: function() {
      let total = 0;
      for(let i = 0; i < this.documents.length; i++) {
        let document = this.documents[i];
        for(let i = 0; i < document.airWaybillTable.airWaybillItems.length; i++) {
          let line = document.airWaybillTable.airWaybillItems[i];
          //console.log(line);
          if(!Number.isNaN(line.numberOfPieces) && line.numberOfPieces) {
            total += line.numberOfPieces;
          }
        }
      }
      return total;
    },
    getTotalGrossWeight: function() {
      let total = 0;
      for(let i = 0; i < this.documents.length; i++) {
        let document = this.documents[i];
        for(let i = 0; i < document.airWaybillTable.airWaybillItems.length; i++) {
          let line = document.airWaybillTable.airWaybillItems[i];
          //console.log(line);
          if(!Number.isNaN(line.grossWeight) && line.grossWeight) {
            total += Number.parseFloat(line.grossWeight);
          }
        }
      }
      return this.financial(total);
    },
    getPrepaidTotal: function() {
      let totalAmount = 0;
      //try {
      for(let i = 0; i < this.form.airWaybillTable.airWaybillItems.length; i++) {
        let line = this.form.airWaybillTable.airWaybillItems[i];
        //console.log(line);
        if(!Number.isNaN(line.totalAmount) && line.totalAmount) {
          totalAmount += Number.parseFloat(line.totalAmount);
        }
      }
      // } catch(err) {
      //
      // }
      return this.financial(totalAmount);
    },
    getTotalWeightCharge: function() {
      let totalAmount = 0;
      for(let i = 0; i < this.form.airWaybillTable.airWaybillItems.length; i++) {
        let line = this.form.airWaybillTable.airWaybillItems[i];
        if(!Number.isNaN(line.totalAmount) && line.totalAmount) {
          totalAmount += Number.parseFloat(line.totalAmount);
        }
      }
      return this.financial(totalAmount);
    },
    getTotalPrepaid: function() {

      let totalAmount = 0;
      totalAmount += parseFloat(this.getTotalWeightCharge());
      totalAmount += parseFloat(this.getTotalOtherChargesDueCarrier());
      totalAmount += parseFloat(this.getTotalOtherChargesDueAgent());


      return this.financial(totalAmount);
    },
    getTotalOtherChargesDueCarrier: function() {
      let totalAmount = 0;
      for(let i = 0; i < this.form.airWaybillTable.otherCharges.length; i++) {
        let line = this.form.airWaybillTable.otherCharges[i];
        if(line.due == "CARRIER" && !Number.isNaN(line.amount) && line.amount) {
          totalAmount += Number.parseFloat(line.amount);
        }
      }
      return this.financial(totalAmount);
    },
    getTotalOtherChargesDueAgent: function() {
      let totalAmount = 0;
      for(let i = 0; i < this.form.airWaybillTable.otherCharges.length; i++) {
        let line = this.form.airWaybillTable.otherCharges[i];
        if(line.due == "AGENT" && !Number.isNaN(line.amount) && line.amount) {
          totalAmount += Number.parseFloat(line.amount);
        }
      }
      return this.financial(totalAmount);
    },
    niceString: function(str) {
      if(str != null) {
        return str.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />');
      }
      return str;
    },
    inited (viewer) {
      console.log("inited");
      this.$viewer = viewer
      this.$viewer.reset = function() {
        return false;
      }
    },
    setActiveRatingLine: function(ratingLine) {
      if(typeof ratingLine == "undefined") {
        ratingLine = this.createRatingLine();
      } else  {
        ratingLine.added = true;
      }

      // console.log(ratingLine);

      this.selectedRatingLine = {...ratingLine};
      this.activeRatingLine = ratingLine;

    },
    createRatingLine: function() {
      let ratingLine = {...this.ratingLineTemplate};
      this.addRatingLineDimension(ratingLine);
      return ratingLine;
    },
    addRatingLineDimension: function(ratingLine) {
      ratingLine.dimensions.push({...this.ratingLineDimensionTemplate});
    },
    saveRatingLine: function(ratingLine) {
      if(typeof ratingLine.added != "undefined" && ratingLine.added == true) {
        this.activeRatingLine = {...ratingLine};
      } else {
        this.addRatingLine(this.form, {...ratingLine});
      }
    },
    addRatingLine: function(form, item) {
      form.consignmentRatingDetails.items.push(item);
    },
    loadForm: function(form, doc) {


      console.log("loadForm", doc);
      this.documentId = doc.id;
      this.showForm = true;
      this.originalForm = JSON.stringify(doc);
      const dateObj = new Date();
      this.startTime = dateObj.toString();
      // this.form = doc;



      this.loadAirports("searchDepartureList", this.searchDepartureList, [this.form.routingDestinationAndChargesDetail.airportOfDeparture], false);
      this.loadAirports("searchArrivalList", this.searchArrivalList, [this.form.routingDestinationAndChargesDetail.airportOfDestination], false);
      return;
    },
    loadFormLists: function(form, doc) {
      // this.loadAirports("searchDepartureList", this.searchDepartureList, [this.form.routingDestinationAndChargesDetail.airportOfDeparture], false);
      // this.loadAirports("searchArrivalList", this.searchArrivalList, [this.form.routingDestinationAndChargesDetail.airportOfDestination], false);
      return;
    },
    startViewer: function() {

    },
    cleanHistoryInput: function(formString) {
      let form = JSON.parse(formString);
      form.history = [];
      form.notes = [];
      return JSON.stringify(form);
    },
    save: async function(type, silent, checkChanges = true) {
      console.log(type);

      
      let form = this.form;
      this.documentId = this.form.id;
      let originalFormString = this.originalForm;

      let snackbar = typeof silent != "undefined" && silent ? false : true;
      // let historyForm = this.cleanHistoryInput(originalFormString);

      //console.log(form.localeCompare(originalForm));
      // console.log(user);
      if(JSON.stringify(this.form) == originalFormString && type == "save") {
        this.snackbarText = "No changes to Air Waybill";
        this.snackbar = snackbar;

      } else {
        
        // console.log("form has changed");

        const dateObj = new Date();
        form.username = user.username;
        form.userId = user.id;
        form.fullname = user.fullname;
        form.history = [this.cleanHistoryInput(originalFormString)].concat(form.history);


        try {
          if(type == "preview") {
            this.messageDialog = true;
            const response = await ApiService.post('/ocr/' + this.documentId + "/document/preview", form);
            this.message = response.data;
            this.sending = false;
            // this.snackbar = true;
            //this.originalForm = JSON.stringify(form);
          } else if(type == "save") {
            const response = await ApiService.post('/ocr/' + this.documentId + "/document", form);
            this.snackbarText = "Air Waybill Saved ";
            this.snackbar = snackbar;
            this.originalForm = JSON.stringify(form);
          } else if(type == "saveAndSend" || type == "saveAndSendAll") {
            
            this.saveAndSendingAll = true;
            if(this.messageEmail) {
              
              this.sending = true;
              try {
                
                let document = "document";
                let message = "Air waybill saved and sent to " + this.messageEmail;
                if(type == "saveAndSendAll") {
                  document = "documents"; 
                  message = "Air waybills saved and sent to " + this.messageEmail;
                }

                console.log("this.snackbarText", "Saving");
                const response = await ApiService.post('/ocr/' + this.documentId + "/" + this.messageEmail + "/" + document, form);
                this.snackbarText = message;
                this.snackbar = true;
                this.originalForm = JSON.stringify(form);

              } catch(err) {

              }
              this.messageDialog = false;
              this.sending = false;
            } else {
              this.snackbarText = "Enter email address";
              this.snackbar = true;
            }

          }
          this.saveAndSendingAll = false;

        }
        catch(err) {
          console.log(err);
          this.snackbarText = "Error : Could Not Save Air Waybill";
          this.snackbar = snackbar;
        }
      }
      this.saveAndSendingAll = false;
    },
    loadFile: function(id) {
      let url = "/ocr/file/" + id;
      let that = this;
      let params = {};
      ApiService.query(url, {
        params: params
      }).then(function(response) {
        that.currentFile = response.data;
        that.documentImage = that.imageUrl + that.currentFile.id + '_' + that.currentFile.name;

        console.log("that.documentImage", that.documentImage);


        that.startViewer();
        // console.log("that.currentFile", that.currentFile);
      }).catch(function(error) {

      });
    },
    loadItems: function(id) {
      let url = "/ocr/" + id + "/documents";
      let that = this;
      let params = {};
      // console.log(url);

      this.showForm = false;

      ApiService.query(url, {
        params: params
      }).then(function(response) {

        that.documents = response.data;
        console.log("that.documents ", that.documents);
        if(that.documents.length) {
          that.setItem(that.documents[0]);
        }


      }).catch(function(error) {

      });
    },
    setItem(document) {



      this.save('save', true);
      this.documentId = document.id;
      this.mSetHAWB(document);
      this.originalForm = JSON.stringify(document);

      // this.loadAirports("searchDepartureList", this.searchDepartureList, [this.form.routingDestinationAndChargesDetail.airportOfDeparture], false);
      // this.loadAirports("searchArrivalList", this.searchArrivalList, [this.form.routingDestinationAndChargesDetail.airportOfDestination], false);
      //
      // this.currentDocument = document;
      // // console.log("set document", this.currentDocument);
      //
      // // console.log("calling loadForm");
      // this.loadForm(this.form, this.currentDocument);
      //
      // if(typeof this.currentDocument.imageUrl == "undefined") {
      //   this.currentDocument.imageUrl = null;
      // }
      //
      // this.documentImage = this.currentDocument.imageUrl;
      // console.log("that.documentImage", this.documentImage);
    },
    loadItem: function(id) {
      let url = "/ocr/" + id + "/document/a";
      let that = this;
      let params = {};
      // console.log(url);

      this.showForm = false;

      ApiService.query(url, {
        params: params
      }).then(function(response) {
        // response.data.id = id;

        that.currentDocument = response.data;
        console.log("that.currentDocument", that.currentDocument);
        that.documentId = id;
        that.loadForm(that.form, that.currentDocument);


        if(typeof that.currentDocument.imageUrl == "undefined") {
          that.currentDocument.imageUrl = null;
        }

        that.documentImage = that.currentDocument.imageUrl;
        console.log("that.documentImage", that.documentImage);
        that.startViewer();

        // that.setData();

      }).catch(function(error) {

      });
    },
    load: function(id, sql, holder, cache) {

      let params = {};
      let that = this;

      if(cache && typeof that[id] != "undefined" && that[id] && that[id].length) {
        return that[id];
      }
      params.sql = window.btoa(sql);
      params.pre = 1;
      params.totalItems = 10000;
      params.rowsPerPage = 10000;

      if(cache) {
        let localCopy = getFromStorage(id);
        if(typeof localCopy != "undefined" && localCopy) {
          holder = JSON.parse(localCopy);
          that[id] = holder;
          // console.log("holder", holder);
          return false;
        }
      }

      ApiService.query('/datasource/sql/' + 979, {
        params: params
      }).then(function(response) {
        try {


          holder = response.data.results;


          that[id] = holder;
          if(cache) {
            saveInStorage(id, JSON.stringify(holder));
          }
          console.log("holder ", holder)
        } catch(err) {

        }

      }).catch(function(error) {

      });
    }

  },
  close: function() {
    // console.log("closed");
  },
  mounted: function() {

    let that = this;

    let id =  typeof this.$route.params.id != 'undefined' ? this.$route.params.id : null;


    id =  typeof this.parameterisedFilterObject.id != 'undefined' ? this.parameterisedFilterObject.id : 3753;

    // this.loadItems(id);
    this.messageEmail = this.email;

    this.$validator.localize('en', dict);

    try {
      //await this.aInit(id);
      console.log("convertHAWBTOMAWBDialog", this.convertHAWBTOMAWBDialog);
      this.originalForm = JSON.stringify(this.form);
      this.documentId = this.form.id;
      this.loadFormLists();
      //console.log("load form list");
    } catch(err) {
      console.log("error", err)
    }


    if(id) {
      let airportSQL = "SELECT concat_ws(' - ', iata, name) as item_text, * FROM airport_airlines_airports_979 WHERE iata IS NOT NULL  ORDER BY iata ASC";
      let airlineSQL = "SELECT concat_ws(' - ', iata_code_mawb, iata_code, iata_airlines) as item_text, * FROM airport_airlines_airlines_979 ORDER BY iata_code_mawb ASC";
      let handlingCodesSQL = "SELECT code, code AS description FROM handling_codes_list_986";
      let currenciesSQL = "SELECT code, concat_ws(' ', symbol, code, description) AS description FROM currencies_list_987";
      let rateClassSQL = "SELECT code, concat_ws(' - ', code, description) AS description FROM rate_card_list_988";
      let otherChargesSQL = "SELECT code,  concat_ws(' - ', code, description) AS description FROM other_charges_list_989";
      let countriesSQL = "SELECT code, name FROM countries_1062";

      // this.load("airports", airportSQL, this.airports);
      this.load("airlines", airlineSQL, this.airlines, true);
      this.load("handlingCodes", handlingCodesSQL, this.handlingCodes, true);
      this.load("currencies", currenciesSQL, this.currencies, true);
      this.load("rateClasses", rateClassSQL, this.rateClasses, true);
      this.load("otherCharges", otherChargesSQL, this.otherCharges, true);
      this.load("countries", countriesSQL, this.countries, true);

      // this.loadItem(id);
      // this.loadFile(id);
    }

    this.interval = setInterval(function() {
      that.validate();
    }, 2000);


  },
  beforeDestroy: function () {
    // console.log("destroy form");
    clearInterval(this.interval);
    try {
      this.airlines = [];
      this.handlingCodes = [];
      this.currencies = [];
      this.rateClasses = [];
      this.otherCharges = [];
      this.countries = [];
      // this.form = {};
      if(this.viewer) {
        this.viewer.destroy();
      }
      
    } catch(err) {
      // console.log('form err', err);

    }
    // this.choicesSelect.destroy()
  }
}

</script>
